import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import CustomButton from "../../components/CustomButton";
import Modal from './components/Modal';
import {getLanguage} from "../../lang/helpers";
import Api from "../../services/Api";


export default function CoachSupportPage() {
  const api = Api.getInstance()
  const translation = useTranslation();
  const { t, i18n } = translation;
  const lang = getLanguage(i18n.language)

  const [description, setDescription] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');


  const openModal = () => {
    const modal = document.getElementById('hs-basic-modal');
    if (modal) {
      modal.classList.remove('hidden');
      modal.classList.add('open');
      modal.classList.add('opened');
    }
  }

  const handleSendSupportTicket = async () => {
    if (!description) {
      setErrorMessage(t('support-error-message'));
      return;
    }

    setIsLoading(true);
    setErrorMessage('');
    const data = {
      description: description
    }
    api.post('coach/support_ticket', data).then((response) => {
      if (response.json.status) {
        setDescription('');
        setIsLoading(false);
        openModal();
      } else {
        setErrorMessage(t('support-error-message-server'));
      }
    }).catch(error => {
      setErrorMessage(t('support-error-message-server'))
      setIsLoading(false);
    })
  };

  return (
    <div className="main-content">
      <h1 className="text-2xl font-medium text-white  mt-4 desktop:mt-6">
        {lang === 'sv' ? 'Hur kan vi hjälpa dig?' : 'How can we assist you?'}
      </h1>
      <p className="mt-2">
        {lang === 'sv' ? 'Beskriv vad du vill ha hjälp med så återkommer vi så snart vi kan.' :
          'Let us know what you need help with, and we\'ll get back to you as soon as possible.'}
      </p>
      <div className="mt-6 gap-2 flex flex-col">
        <div className="p-3 mb-4  h-40 items-center bg-neutral-900 rounded-lg ring-1 ring-neutral-600 focus-within:ring-2 focus-within:ring-primary-500">
          <textarea
            id="description"
            placeholder={lang === 'sv' ? 'Skriv här...' : 'Describe your issue here...'}
            className="w-full h-full flex-1 bg-neutral-900 text-white px-4 py-3 rounded-lg resize-none overflow-y-auto max-h-40 border-none focus:outline-none focus:ring-0 focus:border-0 focus:shadow-none"
            style={{ whiteSpace: 'normal' }}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>
        <CustomButton
          onClick={handleSendSupportTicket}
          className="w-full"
          disabled={isLoading}
        >
          {isLoading ? t('support-sending') : t('send')}
        </CustomButton>
        <Modal title={t('support-modal-success-title')} description={t('support-modal-success-description')} />
        {errorMessage && <p className="mt-4 text-red-500">{errorMessage}</p>}
        <p className="mt-4 text-white">{t('support-email-info')}:</p>
        <p className="text-neutral-400">coach@zebrain.se</p>
      </div>
    </div>
  );
}